import { useMemo } from 'react';
import { useTranslation } from 'next-i18next';
import commonModelIcon from '../assets/ImageCreation/common-model.png';
import animeModelIcon from '../assets/ImageCreation/anime-model.png';
import realisticModelTalkieIcon from '../assets/ImageCreation/realistic-model-t.png';
import realisticModelXingyeIcon from '../assets/ImageCreation/realistic-model-x.png';
import { EImageModelType } from '../types/material';
import { IMAGE_MODEL_ID_MAP } from '../constants/image';
import { isTalkie } from '../utils/env';
// TODO：待更新类型、icon、文案
export interface IImageModel {
  type: EImageModelType;
  name: string;
  icon: string;
  id: string;
}

export function useImageModels() {
  const { t } = useTranslation();
  const models: IImageModel[] = useMemo(() => {
    return [
      {
        type: EImageModelType.Common,
        name: t('imgCommonModelName'),
        icon: commonModelIcon.src,
        id: IMAGE_MODEL_ID_MAP[EImageModelType.Common],
      },
      {
        type: EImageModelType.Anime,
        name: t('imgAnimeModelName'),
        icon: animeModelIcon.src,
        id: IMAGE_MODEL_ID_MAP[EImageModelType.Anime],
      },
      {
        type: EImageModelType.Realistic,
        name: t('imgRealisticModelName'),
        icon: isTalkie ? realisticModelTalkieIcon.src : realisticModelXingyeIcon.src,
        id: IMAGE_MODEL_ID_MAP[EImageModelType.Realistic],
      },
    ];
  }, [t]);

  return { models };
}
